const TipoComiteOptions = [
  {
    label: 'Selecciona',
    value: '',
  },
  {
    label: 'Ejecutivo Nacional',
    value: 'Ejecutivo Nacional',
  },
  {
    label: 'Ejecutivo Estatal',
    value: 'Ejecutivo Estatal',
  },
  {
    label: 'Directivo Estatal',
    value: 'Directivo Estatal',
  }
];

export default TipoComiteOptions;